import { CustomButton, ProcessButton } from 'holistic-resources';
import { ImNewTab } from "react-icons/im";
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import tinycolor from 'tinycolor2';
import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';
import {
  BUTTON_TYPE_BUTTON,
  BUTTON_TYPE_LINK,
  BUTTON_TYPE_SUBMIT,
} from 'shared/constants/common';
import { getButtonStyles } from 'shared/helpers/common';
import { DEFAULT_PRIMARY_COLOUR, DEFAULT_SECONDARY_COLOUR } from 'shared/constants/styleConstants';

export default function Button({
  label = '',
  secondary = false,
  className = '',
  onClick = undefined,
  url = '',
  children,
  type = BUTTON_TYPE_BUTTON,
  disabled = false,
  isNewTab = false,
}) {
  const { theme } = useSelector((state) => state.ui);
  const { whiteLabelSettings: { primaryColour, secondaryColour } = {} } =
    useWhiteLabelSettings();

  const onClickHandler = () => {
    onClick?.();
  };

  const buttonClass = getButtonStyles(className, secondaryColour);
  const buttonStyle = secondary
    ? {
        color: theme.brandColour || primaryColour,
        borderColor: theme.secondaryColour || secondaryColour || DEFAULT_SECONDARY_COLOUR,
        borderStyle: 'solid',
        borderWidth: '2px',
      }
    : {
        backgroundColor: theme.primaryColour || primaryColour || DEFAULT_PRIMARY_COLOUR,
        borderColor: theme.primaryColour || primaryColour || DEFAULT_PRIMARY_COLOUR,
        color: '#fff',
      };

  if (disabled) {
    buttonStyle.backgroundColor = tinycolor(buttonStyle.backgroundColor)
      .setAlpha(0.4)
      .toString();

    buttonStyle.borderColor = tinycolor(buttonStyle.borderColor)
      .setAlpha(0.1)
      .toString();

    buttonStyle.cursor = 'default';
  }

  buttonStyle.height = '50px';
  buttonStyle.fontSize = '15px';

  if (type === BUTTON_TYPE_LINK && url) {
    if (isNewTab) {
      return (
        <a
          href={url}
          style={buttonStyle}
          className={buttonClass}
          onClick={onClickHandler}
          target="_blank"
          rel="noopener noreferrer"
        >
          {label || children}
          <ImNewTab className='text-xl ml-1' />
        </a>
      );
    }
    return (
      <Link
        to={url}
        style={buttonStyle}
        className={buttonClass}
        onClick={onClickHandler}
      >
        {label || children}
      </Link>
    );
  }

  if (type === BUTTON_TYPE_SUBMIT) {
    return (
      <ProcessButton
        disabled={disabled}
        onClick={onClickHandler}
        style={buttonStyle}
        className={buttonClass}
      >
        {label || children}
      </ProcessButton>
    );
  }

  return (
    <CustomButton
      disabled={disabled}
      style={buttonStyle}
      onClick={onClickHandler}
      className={buttonClass}
    >
      {label || children}
    </CustomButton>
  );
}
